import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { Grid, Button } from '@material-ui/core';
import { Cancel } from '@material-ui/icons';
import { SCHEDULE } from 'consts';
import { withTransactAsPayerPermission } from 'components/common/permissions';
import useFlags from 'components/modules/implementation/Fsp/Detail/common/hooks/useFeatureFlags';
import { useFSPConfig } from 'hooks';
import GuestScheduledAudit from './GuestScheduledAudit';

const GuestScheduledActionsRenderer = ({ item, onCancelClick }) => {
  const { fspId, status } = item;
  const [loading, setLoading] = useState(false);
  const fspConfig = useFSPConfig(item.fspId, true);

  const {
    data,
    loading: flagLoading,
    error,
  } = useFlags('ontrac-guest-cancel-payment');
  const [featureFlagEnabled, setFeatureFlagEnabled] = useState(false);

  useEffect(() => {
    if (!flagLoading && data !== null && data.FlagValue !== null) {
      setFeatureFlagEnabled(data.FlagValue);
    }
  }, [data, flagLoading, error]);

  const transactOnBehalfOn = fspConfig?.transactOnBehalfOffOn === 'on';
  const transactPalOn =
    fspConfig?.transactOnBehalfConfig?.transactPalOffOn === 'on';

  const showCancelButton =
    featureFlagEnabled &&
    transactOnBehalfOn &&
    transactPalOn &&
    status === SCHEDULE;

  const handleCancelClick = async () => {
    setLoading(true);
    try {
      await onCancelClick(item);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Grid container justifyContent="flex-end" spacing={1}>
      <Grid item>
        <GuestScheduledAudit item={item} />
      </Grid>
      {showCancelButton && (
        <Grid item>
          <Button
            color="secondary"
            onClick={handleCancelClick}
            size="small"
            startIcon={<Cancel />}
            variant="outlined"
            disabled={loading}
            style={{
              opacity: 1,
              filter: 'none',
              pointerEvents: 'auto',
              color: '#a452b2',
              borderColor: '#a452b2',
            }}
          >
            {loading ? 'Cancelling...' : 'Cancel Payment'}
          </Button>
        </Grid>
      )}
    </Grid>
  );
};

GuestScheduledActionsRenderer.propTypes = {
  item: PropTypes.object.isRequired,
  onCancelClick: PropTypes.func.isRequired,
};

export default withTransactAsPayerPermission(GuestScheduledActionsRenderer);
